module.exports = __webpack_public_path__ + "images/greenflux3b4fa7944e766fcef399733ce83975c9.png";